export default __webpack_public_path__ + "static/media/Scholar's Bands of the Heavens.9319c5c5.jpg";